import * as React from 'react';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { ApplicationState } from '../../Store';

import {
    GetBasicSettings,
    GetTenantName,
} from '../../Store/Tenant';

import { StringFormat } from '../../Utils/StringUtils';
import { DefaultStrongboxInfoLink } from '../../Utils/Constants';

type InjectedReduxState = {
    lenderName: string;
    strongboxInfoLink: string;
};

type InjectedActionCreators = {};

type TenantUsesStrongboxWithLinkProps = {
    msgTemplate: string;
    learnMore: string;
    learnMoreLabel: string;
};

type Props = TenantUsesStrongboxWithLinkProps & InjectedReduxState & InjectedActionCreators;

const TenantUsesStrongboxWithLinkComponent: React.FC<Props> = (props): React.ReactElement => {
    const {
        learnMore,
        learnMoreLabel,
        lenderName,
        msgTemplate,
        strongboxInfoLink,
    } = props;

    const mainMessage = React.useMemo(() => {
        return StringFormat(msgTemplate, lenderName);
    }, [msgTemplate, lenderName])

    return (
        <React.Fragment>
            <p>
                {`${mainMessage} `}
            </p>
            <a
                href={strongboxInfoLink}
                className={'normal-link-color'}
                rel={'noopener noreferrer'}
                target={'_blank'}
                aria-label={learnMoreLabel}
            >
                {learnMore}
            </a>
        </React.Fragment>
    );
}

export const TenantUsesStrongboxWithLink = connect<InjectedReduxState, InjectedActionCreators, TenantUsesStrongboxWithLinkProps, ApplicationState>(
    (appState: ApplicationState) => {
        const basicSettings = GetBasicSettings(appState);

        const result: InjectedReduxState = {
            lenderName: GetTenantName(appState),
            strongboxInfoLink: (basicSettings && basicSettings.StrongboxSecurityInfoLink) || DefaultStrongboxInfoLink,
        };

        return result;
    },
    dispatch => bindActionCreators(
        {
        },
        dispatch
    )
)(TenantUsesStrongboxWithLinkComponent);
